// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".message-icon[data-v-122a8ac4]{margin-right:32px}.no-data[data-v-122a8ac4]{display:flex;align-items:center;justify-content:center;padding:16px;width:75%;margin-left:auto;margin-right:auto;border-radius:4px;box-shadow:0 1px 3px 0 rgba(0,0,0,.2),0 1px 1px 0 rgba(0,0,0,.14),0 2px 1px -1px rgba(0,0,0,.12);overflow:hidden;color:var(--secondary-color)}", ""]);
// Exports
module.exports = exports;
